<template>
  <!-- 城市组件 -->
  <div v-checkoutside="handleClose" class="tt-rlt">
    <el-input
      v-model="value"
      class="cityInput"
      placeholder="中文/三字码"
      :type="$attrs.type"
      @focus="selectCity"
      @input="filterCity"
    />
    <div v-show="cityBoxShow" :style="style" class="cityBox">
      <p class="cityBox-header">
        请选择城市或输入城市名称的拼音或英文
        <i
          class="iconfont tt-fr"
          style="cursor: pointer; margin-right: 10px"
          @click="hideCityBox()"
          >&#xe65e;</i
        >
      </p>
      <div v-if="$attrs.type == 'I'" class="cityInner">
        <ul class="cityBoxTabs clearFix">
          <li class="titile">国际城市</li>
          <li
            :class="{ active: 'hot' === activeIIndex }"
            @click="changeCode('I', 'hot')"
          >
            热门
          </li>
          <li
            :class="{ active: 'ASIA' === activeIIndex }"
            @click="changeCode('I', 'ASIA')"
          >
            亚洲
          </li>
          <li
            :class="{ active: 'EUROPE' === activeIIndex }"
            @click="changeCode('I', 'EUROPE')"
          >
            欧洲
          </li>
          <li
            :class="{ active: 'AMERICA' === activeIIndex }"
            @click="changeCode('I', 'AMERICA')"
          >
            美洲
          </li>
          <li
            :class="{ active: 'AFRICA' === activeIIndex }"
            @click="changeCode('I', 'AFRICA')"
          >
            非洲
          </li>
          <li
            :class="{ active: 'OCEANIA' === activeIIndex }"
            @click="changeCode('I', 'OCEANIA')"
          >
            大洋洲
          </li>
        </ul>
        <div
          v-for="item in cityListI"
          :key="item.index"
          class="cityBoxContainer clearFix"
        >
          <ul class="tt-fl">
            <li v-for="city in item" :key="city.index" @click="checkCity(city)">
              {{ city.cityCName }}
            </li>
          </ul>
        </div>
        <ul class="cityBoxTabs clearFix">
          <li class="titile">国内城市</li>
          <li
            :class="{ active: 'hot' === activeDIndex }"
            @click="changeCode('D', 'hot')"
          >
            热门
          </li>
          <li
            v-for="(city, idx) in cityCodeD"
            :key="city.id"
            :class="{ active: idx === activeDIndex }"
            @click="changeCode('D', idx, city)"
          >
            {{ city }}
          </li>
        </ul>
        <div
          v-for="(item, key) in cityListD"
          :key="item.index"
          class="cityBoxContainer clearFix"
        >
          <div v-if="key !== 'hot'" class="title clearFix tt-fl">{{ key }}</div>
          <ul class="tt-fl">
            <li v-for="city in item" :key="city.index" @click="checkCity(city)">
              <template>{{ city.cityCName }}</template>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="cityInner">
        <ul class="cityBoxTabs clearFix">
          <li class="titile">国内城市</li>
          <li
            :class="{ active: 'hot' === activeDIndex }"
            @click="changeCode('D', 'hot')"
          >
            热门
          </li>
          <li
            v-for="(city, idx) in cityCodeD"
            :key="city.id"
            :class="{ active: idx === activeDIndex }"
            @click="changeCode('D', idx, city)"
          >
            {{ city }}
          </li>
        </ul>
        <div
          v-for="(item, key) in cityListD"
          :key="item.index"
          class="cityBoxContainer clearFix"
        >
          <div v-if="key !== 'hot'" class="title clearFix tt-fl">{{ key }}</div>
          <ul class="tt-fl">
            <li v-for="city in item" :key="city.index" @click="checkCity(city)">
              <template>{{ city.cityCName }}</template>
            </li>
          </ul>
        </div>
        <template v-if="$attrs.type != 'D'">
          <ul class="cityBoxTabs clearFix">
            <li class="titile">国际城市</li>
            <li
              :class="{ active: 'hot' === activeIIndex }"
              @click="changeCode('I', 'hot')"
            >
              热门
            </li>
            <li
              :class="{ active: 'ASIA' === activeIIndex }"
              @click="changeCode('I', 'ASIA')"
            >
              亚洲
            </li>
            <li
              :class="{ active: 'EUROPE' === activeIIndex }"
              @click="changeCode('I', 'EUROPE')"
            >
              欧洲
            </li>
            <li
              :class="{ active: 'AMERICA' === activeIIndex }"
              @click="changeCode('I', 'AMERICA')"
            >
              美洲
            </li>
            <li
              :class="{ active: 'AFRICA' === activeIIndex }"
              @click="changeCode('I', 'AFRICA')"
            >
              非洲
            </li>
            <li
              :class="{ active: 'OCEANIA' === activeIIndex }"
              @click="changeCode('I', 'OCEANIA')"
            >
              大洋洲
            </li>
          </ul>
          <div
            v-for="item in cityListI"
            :key="item.index"
            class="cityBoxContainer clearFix"
          >
            <ul class="tt-fl">
              <li
                v-for="city in item"
                :key="city.index"
                @click="checkCity(city)"
              >
                {{ city.cityCName }}
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <div v-show="searchBoxShow" :style="style" class="searchBox">
      <i
        class="iconfont tt-fr"
        style="cursor: pointer; color: #999"
        @click="hideSearchBox()"
        >&#xe65e;</i
      >
      <ul>
        <li v-for="val in dataList" :key="val.index" @click="checkCity(val)">
          <el-tag
            :type="val.idSign === 'I' || val.idSign === 'D' ? '' : 'success'"
            effect="dark"
          >
            <slot>
              {{ val.idSign === "I" || val.idSign === "D" ? "机场" : "火车站" }}
            </slot>
          </el-tag>
          {{ val[echoCityName(val.airportCode)] }} ({{ val.airportCode }})
        </li>
        <li v-if="dataList.length == 0">非常抱歉，暂时还没有此地点</li>
      </ul>
    </div>
  </div>
</template>
<script>
import checkoutside from '@utils/checkoutside'
import { mapState } from 'vuex'
import { echoCityName } from '@utils/common'
export default {
  name: 'city',
  props: {
    port: {
      type: String,
      default: ''
    }
  },
  directives: {
    checkoutside
  },
  data () {
    return {
      value: '',
      cityBoxShow: false,
      searchBoxShow: false,
      activeDIndex: 'hot',
      cityCodeListD: [],
      cityCodeObjD: {},
      cityCodeD: [],
      cityListD: {},
      activeIIndex: 'hot',
      cityCodeListI: [],
      cityCodeObjI: {},
      cityCodeI: [],
      cityListI: {},
      dataList: [],
      style: {}
    }
  },
  updated () {
    this.value = this.$attrs.value
  },
  mounted () {
    this.value = this.$attrs.value
    function initAirPort () {
      const airport = that.$store.state.indexStore.airport.airportList
      if (airport.length < 1) {
        return
      }
      let airportD = airport.filter(item => {
        return item.airportPosition === 'D'
      })
      airportD = airportD.sort((a, b) => {
        if (
          a.citySpell.charAt(0).toUpperCase() >
          b.citySpell.charAt(0).toUpperCase()
        ) {
          return 1
        } else if (
          a.citySpell.charAt(0).toUpperCase() <
          b.citySpell.charAt(0).toUpperCase()
        ) {
          return -1
        } else {
          return 0
        }
      })
      airportD.forEach(item => {
        const charCode = item.citySpell.charAt(0).toUpperCase()
        if (that.cityCodeObjD.hasOwnProperty(charCode)) {
          that.cityCodeObjD[charCode].push(item)
        } else {
          that.cityCodeObjD[charCode] = [item]
        }
      })
      const airportI = airport.filter(item => {
        return item.areaCode
      })
      airportI.forEach(item => {
        let charCode = item.areaCode.replace(/\s/g, '').toUpperCase()
        if (charCode.indexOf('AMERICA') !== -1) {
          charCode = 'AMERICA'
        }
        if (that.cityCodeObjI.hasOwnProperty(charCode)) {
          that.cityCodeObjI[charCode].push(item)
        } else {
          that.cityCodeObjI[charCode] = [item]
        }
      })
      that.cityCodeI = Object.keys(that.cityCodeObjI)
      that.cityCodeD = Object.keys(that.cityCodeObjD)
        .join('')
        .match(/\w{1,4}/g)
      that.cityListI['hot'] = airportI.filter(item => {
        return (
          item.airportPosition === 'I' &&
          item.isHot === 'Y' &&
          item.cityCode === item.airportCode
        )
      })
      that.cityListD['hot'] = airportD.filter(item => {
        return (
          item.isHot === 'Y' &&
          item.airportPosition === 'D' &&
          item.cityCode === item.airportCode
        )
      })
    }
    const that = this
    initAirPort()
  },
  computed: {
    ...mapState(['indexStore'])
  },
  methods: {
    changeCode (key, idx, cityCode) {
      this[`active${key}Index`] = idx
      const airport = this.indexStore.airport.airportList
      const that = this
      that['cityList' + key] = {}
      if (idx === 'hot') {
        that['cityList' + key]['hot'] = airport.filter(item => {
          return (
            item.isHot === 'Y' &&
            item.airportPosition === key &&
            item.cityCode === item.airportCode
          )
        })
        return
      }
      if (key === 'D') {
        this['cityCodeList' + key] = cityCode.match(/\w{1}/g)
        this['cityCodeList' + key].forEach(item => {
          if (that['cityCodeObj' + key].hasOwnProperty(item)) {
            that['cityList' + key][item] = that['cityCodeObj' + key][item]
          }
        })
      } else {
        this['cityList' + key][idx] = that['cityCodeObj' + key][idx]
      }
    },
    hideCityBox () {
      this.cityBoxShow = false
    },
    echoCityName (code) {
      return echoCityName(code)
    },
    checkCity (item) {
      this.cityBoxShow = false
      this.searchBoxShow = false
      this.city = item
      let k = this.echoCityName(item.airportCode)
      this.value = `${item[k]}(${item.airportCode})`
      this.$emit('input', this.value)
    },
    handleClose () {
      this.cityBoxShow = false
      this.searchBoxShow = false
    },
    selectCity (key) {
      const point = event.target.getBoundingClientRect()
      this.cityBoxShow = true
      this.style = this.$attrs.customStyle || {
        top: point.height + 1 + 'px'
      }
    },
    checkSearchCity (item, searchBox) {
      let k = this.echoCityName(item.airportCode)
      this.$attrs.value = `${item[k]}(${item.airportCode})`
      this.searchBoxShow = false
    },
    filterCity (e) {
      var keyword = this.value.replace(/\s/g, '').toUpperCase()
      this.$emit('input', keyword)
      this.dataList = []
      this.cityBoxShow = false
      this.searchBoxShow = true
      if (keyword.length === 0) {
        this.cityBoxShow = true
        return
      }
      const airport = this.indexStore.airport.airportList
      // if (this.$attrs.type !== 'D' && keyword.length <= 1) {
      //   return
      // }
      const searchList = airport.filter(item => {
        if (/[a-zA-Z]/.test(keyword) && keyword.length <= 3) {
          return (
            item.cityCode &&
            item.airportCode.match(keyword) &&
            (this.$attrs.type === 'D'
              ? item.airportPosition === this.$attrs.type
              : true)
          )
        } else {
          return (
            item.cityCode &&
            (item.airportCode.match(keyword) ||
              item.citySpell.toUpperCase().match(keyword) ||
              item.cityCName.match(keyword) ||
              item.airportCName.match(keyword)) &&
            (this.$attrs.type === 'D'
              ? item.airportPosition === this.$attrs.type
              : true)
          )
        }
      })
      this.dataList = searchList
    },
    hideSearchBox () {
      this.searchBoxShow = false
    }
  }
}
</script>
<style lang="less">
.cityInput input {
  text-transform: uppercase;
}
</style>
<style lang="less" scoped>
.cityBox {
  position: absolute;
  width: 600px;
  left: 0;
  top: 0;
  font-size: 12px;
  background-color: #fff;
  -moz-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  -webkit-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  border: 1px solid #98a1b3;
  font-family: arial, SimSun, Verdana, Geneva, Helvetica;
  z-index: 9999;
  padding-bottom: 8px;
  border-radius: 10px;
}
.cityBox-header {
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  color: #999;
}
.cityBoxTabs li {
  float: left;
  color: #006eff;
  padding: 0 9px;
  height: 26px;
  line-height: 26px;
  cursor: pointer;
}
.cityBoxTabs li.active {
  color: #fff;
  padding: 0 8px;
  font-weight: 700;
  background-color: #006eff;
  border-radius: 3px 3px 0 0;
}
.cityBoxTabs {
  border-bottom: 1px #d7d7d7 solid;
}
.cityBoxTabs .titile {
  font-size: 16px;
  color: #333;
  padding: 0 9px;
}
.cityBoxContainer {
  padding-top: 5px;
  max-height: 70px;
  overflow: hidden;
  display: flex;
}
.cityBoxContainer .title {
  color: #006eff;
  padding: 0 5px;
  position: relative;
  left: 6px;
  margin: 0;
}
.cityBoxContainer ul {
  padding-left: 26px;
}
.cityBoxContainer ul li {
  float: left;
  width: 100px;
  margin-right: 10px;
  height: 24px;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  padding: 0 2px;
}
.cityBoxContainer ul li:hover {
  color: #fff;
  background-color: #006eff;
}
.searchBox {
  width: 360px;
  position: absolute;
  left: 0;
  top: 0;
  word-spacing: 0;
  font-size: 12px;
  background-color: #fff;
  -webkit-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  border: 1px solid #98a1b3;
  font-family: arial, SimSun, Verdana, Geneva, Helvetica;
  z-index: 120;
  border-radius: 10px;
  padding: 10px;
  max-height: 330px;
  overflow: hidden;
}
.searchBox ul li {
  margin-bottom: 10px;
  cursor: pointer;
}
.searchBox ul li:hover {
  // background-color: #006eff;
  color: #006eff;
  font-size: 12px;
  font-weight: bold;
}
.el-tag {
  width: 54px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/City.vue